// extracted by mini-css-extract-plugin
module.exports = {"profile":"style_profile__KZQMV","left":"style_left__16Rt8","right":"style_right__1wOMW"};